<template>
  <div name="demo-chart-pie">
  	chart pie
  </div>
</template>

<script>
export default {
  name: 'demo-chart-pie'
}
</script>


// WEBPACK FOOTER //
// demoChartPie.vue?4b6251ca